import { ItemClass, ItemClasses } from '../common/constants'

export type CatalogItem = {
  id: number
  guid: string
  tenantId: number
  class: ItemClass
  name: string
  description?: string
  sku?: string
  units?: string
  cost: number
  taxable: boolean
  overtimeFactor?: number
  unbillablePercent?: number
  laborBurden?: number
  customPrice?: number
  customProfitMargin?: number
  categories: string[]
  tags: string[]
  rateInstallationQuantity?: number
  ratePerUnits?: string
  rateUsageQuantity?: number
  adjustedCost: number
  isHidden: boolean
  retiredAt?: string
  addedAt?: string
  priceLastUpdatedAt?: string
  lastUsedAt?: string

}

export const defaultCatalogItem = (): CatalogItem => {
  return {
    id: 0,
    guid: '',
    tenantId: 0,
    class: ItemClasses.Materials,
    name: '',
    cost: 0,
    taxable: false,
    categories: [],
    tags: [],
    adjustedCost: 0,
    isHidden: false
  }
}

export const calculateAdjustedCost = (item: Pick<CatalogItem, 'overtimeFactor' | 'unbillablePercent' | 'laborBurden' | 'cost'>): number => {
  const adjustments = [
    item.overtimeFactor,
    item.unbillablePercent,
    item.laborBurden
  ].filter(x => x !== undefined) as number[]
  return Math.round(adjustments.reduce((a, x) => a * (1 + (x / 100)), item.cost))
}
